export default "__VITE_ASSET__DsFjKiy8__"